export default "__VITE_ASSET__DpjcjPuh__"